import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Custom hook to toggle a student's active/inactive status
 */
export const useToggleStudentStatus = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const { axiosInstance } = useAxios();

    /**
     * Toggle student status
     * @param {number|string} studentId - The student ID
     * @param {(success: boolean) => void} [onSuccess] - Callback on success
     * @returns {Promise<void>}
     */
    const toggleStudentStatus = async (studentId, onSuccess) => {
        try {
            setLoading(true);
            setError("");
            setSuccess(false);

            const url = `${TENANT_DOMAIN}/student/${studentId}/toggle-status`;
            await axiosInstance.patch(url);

            setSuccess(true);

            if (onSuccess) {
                onSuccess(true);
            }
        } catch (err) {
            setSuccess(false);

            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }

            if (onSuccess) {
                onSuccess(false);
            }
        } finally {
            setLoading(false);
        }
    };

    const resetState = () => {
        setError("");
        setSuccess(false);
    };

    return {
        loading,
        error,
        success,
        toggleStudentStatus,
        resetState,
    };
};